import { render, staticRenderFns } from "./SecurityIcon.vue?vue&type=template&id=40101c10&"
import script from "./SecurityIcon.vue?vue&type=script&lang=ts&"
export * from "./SecurityIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports